module.exports = __webpack_public_path__ + "img/eyein-partner-cisco.a1308bc6.webp";